import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=43a37f14&"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports